import { Link } from 'react-router-dom';
import { useDisclaimer } from './DisclaimerModal';

const SiteFooter = () => {
  const { openDisclaimer } = useDisclaimer();

  return (
    <footer className="mt-16 pt-8 border-t border-slate-200">
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[13px] text-slate-600" aria-label="Site">
        <Link to="/" className="hover:text-slate-900 transition">
          Calculator
        </Link>
        <a href="/articles/" className="hover:text-slate-900 transition">
          Articles
        </a>
        <a href="/about/" className="hover:text-slate-900 transition">
          About
        </a>
        <a href="/privacy/" className="hover:text-slate-900 transition">
          Privacy
        </a>
      </nav>
      <p className="mt-4 text-[12px] text-slate-400 leading-relaxed max-w-[640px]">
        Educational tool only — not financial advice. See the{' '}
        <button
          type="button"
          onClick={openDisclaimer}
          className="text-emerald-700 underline underline-offset-2 decoration-amber-700/40 hover:text-emerald-800 hover:decoration-emerald-800 transition font-inherit text-[12px] p-0 border-0 bg-transparent cursor-pointer"
        >
          calculator disclaimer
        </button>{' '}
        for full terms.
      </p>
    </footer>
  );
};

const SiteHeader = ({ subtitle = 'Money-in-your-pocket pension planning' }) => (
  <header className="flex flex-wrap items-center justify-between gap-y-3 pb-7 mb-7 border-b border-slate-200">
    <Link to="/" className="flex items-center gap-3 group no-underline">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden="true">
        <path
          d="M18 4 C 11 4, 7 13, 7 21 C 7 27, 12 32, 18 32 C 24 32, 29 27, 29 21 C 29 13, 25 4, 18 4 Z"
          stroke="#059669"
          strokeWidth="1.8"
          fill="none"
        />
        <circle cx="18" cy="21" r="5" fill="#059669" />
      </svg>
      <div>
        <div
          className="text-[26px] leading-none tracking-tight text-slate-900 group-hover:text-slate-700 transition"
          style={{ fontFamily: 'ui-serif, Georgia, "Times New Roman", serif' }}
        >
          caniretire<span className="text-slate-400">.uk</span>
        </div>
        <div className="mt-1.5 text-[11px] font-medium tracking-wide text-emerald-700">{subtitle}</div>
      </div>
    </Link>
  </header>
);

const SiteLayout = ({ children, subtitle }) => (
  <div
    className="min-h-screen w-full bg-stone-50 text-slate-900"
    style={{ fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' }}
  >
    <div className="max-w-[760px] mx-auto px-10 py-8">
      <SiteHeader subtitle={subtitle} />
      <main>{children}</main>
      <SiteFooter />
    </div>
  </div>
);

export { SiteFooter, SiteHeader };
export default SiteLayout;
